
// NATIVE 

// INSTALLED 
import { setCountrySelectRedux } from './countrySlice';
import { getCountries } from '../../services/country.service';
import { checkingPreload, unCheckingPreload } from '../loading';


// CUSTOM 




export const getCountryForSelect = (): any => {

  return async( dispatch: any ) => {
     

      await dispatch( checkingPreload() );

      const result = await  getCountries();


      if ( result.ok ) {

        await dispatch( setCountrySelectRedux(result.data) );

      }
      
      dispatch( unCheckingPreload() );

      return result;


  }


}